export default {
  GENERAL_ADMISSION: 'general',
  SEATED: 'seated',
};
